import React from 'react';
import { Heart } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p className="footer-text">
            <Heart size={16} className="heart-icon" />
            {' '}GEMEINDE MPEV - Ministère de la Parole, Esprit et Vie{' '}
            <Heart size={16} className="heart-icon" />
          </p>
          <p className="footer-verse">
            "C'est l'esprit qui vivifie; la chair ne sert de rien. Les paroles que je vous ai dites sont esprit et vie."
            <br />
            <span className="verse-ref">Jean 6:63 / John 6:63 / Johannes 6:63</span>
          </p>
          <p className="copyright">
            © {currentYear} Gemeinde MPEV Munich. Tous droits réservés / All rights reserved / Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
